// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__1uKtO","inputWrap":"Table_inputWrap__1obWk","col":"Table_col__1C6OM","bmiTooltip":"Table_bmiTooltip__85ynT"};